import React, { useEffect, useState } from "react";
import { CardElement, useStripe, useElements, Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { API_BASE_URL, STRIPE_PUBLISHABLE_KEY } from "../../config";

const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);

function AddPaymentMethodForm({ clientSecret, type, setType, onMethodAdded }) {
    const stripe = useStripe();
    const elements = useElements();
    const [status, setStatus] = useState("");
    const [customName, setCustomName] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!stripe || !elements || !clientSecret) return;

        setStatus("Processing...");

        let result;
        // Only support card payment methods
        result = await stripe.confirmCardSetup(clientSecret, {
            payment_method: { card: elements.getElement(CardElement) }
        });

        if (result.error) {
            setStatus(result.error.message);
        } else {
            setStatus("Payment method added!");
            if (onMethodAdded) onMethodAdded();
        }

        if (result.setupIntent && result.setupIntent.payment_method && customName.trim()) {
            await fetch(`${API_BASE_URL}/api/customer/payment-methods/${result.setupIntent.payment_method}/name`, {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${localStorage.getItem("token")}`,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ name: customName.trim() })
            });
        }
    };

    return (
        <form onSubmit={handleSubmit} style={{ maxWidth: 400, margin: "2rem auto" }}>
            <h3>Add Payment Method</h3>
            <div>
                <label>
                    <input
                        type="radio"
                        value="card"
                        checked={true}
                        readOnly
                    /> Card
                </label>
            </div>
            <CardElement />
            <div style={{ marginTop: 12 }}>
                <label>
                    Name this payment method (optional):<br />
                    <input
                        type="text"
                        value={customName}
                        onChange={e => setCustomName(e.target.value)}
                        placeholder="e.g. Personal Visa"
                        style={{ width: "100%", padding: "0.5em", marginTop: 4 }}
                    />
                </label>
            </div>
            <button type="submit" disabled={!stripe || !clientSecret} style={{ marginTop: 16 }}>
                Save Payment Method
            </button>
            <div style={{ marginTop: 12, color: "#ea476e" }}>{status}</div>
        </form>
    );
}

function AddPaymentMethod({ onMethodAdded }) {
    const [clientSecret, setClientSecret] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function setup() {
            setLoading(true);
            // Create Stripe customer if not exists
            await fetch(`${API_BASE_URL}/api/customer/create-stripe-customer`, {
                method: "POST",
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
            });
            // Get SetupIntent
            const res = await fetch(`${API_BASE_URL}/api/customer/create-setup-intent`, {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${localStorage.getItem("token")}`,
                    "Content-Type": "application/json"
                }
            });
            const data = await res.json();
            setClientSecret(data.clientSecret);
            setLoading(false);
        }
        setup();
    }, []);

    if (loading || !clientSecret) return <div>Loading payment form...</div>;

    return (
        <Elements stripe={stripePromise} options={{ clientSecret }}>
            <AddPaymentMethodForm
                clientSecret={clientSecret}
                onMethodAdded={onMethodAdded}
            />
        </Elements>
    );
}

export default AddPaymentMethod;